import { useState } from "react";
import {Box, Typography} from "@mui/material";

export default function TransactionLog({data, itemClass}) {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const dateSection = []
  
  const populatedItem= (item) => {
    const allItems = data
    const soldItem = item.pk.replace('buy', 'sold');
    const burnedItem = item.pk.replace('buy', 'burn');
    const getFollowUpAction = allItems.filter(
      obj => obj.pk === soldItem || obj.pk === burnedItem
    );
    item.followUp = []
    if (getFollowUpAction.length > 0) {
      const followUpItem = getFollowUpAction[0];
      // this will be scrapped once i get the value in the DB
      followUpItem.valueDiff = parseFloat(followUpItem.totalAmount) - parseFloat(item.totalAmount); 
      item.followUp.push(followUpItem)
    }
    return item
  }

  const formatTime = (timeStamp) => {
    const date = new Date(timeStamp);
    return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
  }

  const dataDivider = (timeStamp) => {
    const date = new Date(timeStamp).toLocaleDateString();
    if(!dateSection.includes(date)) {
      console.log('here', dateSection)
      dateSection.push(date);
      // return a divider
      
      return (
        <Box sx={{ width: '100%', textAlign: 'center', my: 2 }}>
          <Typography variant="h7" component="div" sx={{ color: '#888' }}>
            -- {date} --
          </Typography>
        </Box>
      );
    }
  }

  return (
    <Box className={itemClass} display="flex" justifyContent="space-between" alignItems="center" p={2}>
      {data.map((item, i) => {
        const {sk, asset, action} = item;
        if(action === 'buy') {
          const newItem = populatedItem(item);
          /* console.log('newItem', newItem); */
          return (
            <Box key={sk + i} className="logItem" sx={{ width: '100%', mb: 1 }}>
              {dataDivider(sk)}
               {/* <span>{newItem.followUp.length > 0 ? formatTime(newItem.followUp[0].sk) : formatTime(sk)}</span> */}
               <span style={{ width: '64px', display: 'inline-block' }}>{formatTime(sk)}</span>
               {" "} <span style={{ width: '54px', display: 'inline-block', color:'white' }}>{asset.split('-')[0]}</span> {" "}
               <span className={newItem.followUp.length > 0 ? 'strikeThrough' : ''} style={{ fontWeight: 'bolder', color: '#97b6ff', display: 'inline-block' }}>{action}</span> {" "}

              {newItem.followUp.length > 0 && 
                <span style={{ fontWeight: 'bolder', color: newItem.followUp[0].valueDiff >= 0 ? '#66ed66' : 'red' }}>
                  {newItem.followUp[0].action + ' ' } {newItem.followUp[0].valueDiff >= 0 ? '(+' : '('}{'$'+newItem.followUp[0].valueDiff.toFixed(2)+ ')'}
                </span>
              }

              {/* <span style={{ fontWeight: 'bolder', color: action === 'sold' ? '#66ed66' : action === 'burn' ? 'red' : '#97b6ff' }}>
                {action}
              </span>{" "} */}
              
            </Box>
          )
        }
      })}
  </Box>
  )
}